import { useCallback, useMemo, useState } from "react"
import { useMutation } from "@tanstack/react-query"
import i18n, { languagesMap, languagesTransformer } from "i18n"
// context
import useAuthenticationContext from "context/Authentication/useAuthenticationContext"
// api
import { updateUserData, UpdateUserDataRequest } from "api"

export const useToggleLanguage = () => {
  const {
    user: { documentId, userProfileDocumentId },
    refetchUser,
  } = useAuthenticationContext()

  const { mutate: updateUserLocaleMutate } = useMutation<unknown, unknown, UpdateUserDataRequest>({
    mutationFn: updateUserData,
    onSuccess: () => {
      i18n.changeLanguage(selectedLng.value)
      refetchUser()
    },
  })

  const languagesArray = useMemo(() => {
    const languagesArray = []

    for (const languageKey in languagesMap) {
      languagesArray.push({ label: languagesMap[languageKey], value: languageKey })
    }

    return languagesArray
  }, [languagesMap])

  const [selectedLng, setSelectedLang] = useState(() => {
    const mappedLanguage = (languagesTransformer as Record<string, string>)[i18n.language]
    return languagesArray.find((l) => l.value === mappedLanguage) || languagesArray[0]
  })

  const handleChangeSelectedLng = useCallback((e: React.SyntheticEvent, value: any) => {
    setSelectedLang(value)
  }, [])

  const handleChangeLng = useCallback(() => {
    updateUserLocaleMutate({ userLocale: selectedLng.value, documentId, userProfileDocumentId })
  }, [selectedLng])

  return { languagesArray, selectedLng, handleChangeSelectedLng, handleChangeLng }
}
